import React from "react";

import { SearchableSelect } from "app/Components/SearchableSelect/SSingleSelect";
import { FormGroup } from "react-bootstrap";
import Label from "../Label/Label";

import InputError from "../InputError/InputError";

function FormSelect({
  label,

  name,
  value,
  onChange,
  disabled,

  blankSelect,
  style,
  array,
  object,

  menuPortalTarget,

  className,
  error,
  errorClassName,

  KEY_label,
  KEY_value,

  options,
  component = null,
  placeholder,
}) {
  return (
    <FormGroup>
      {label && <Label>{label}</Label>}

      <SearchableSelect
        name={name ? name : ""}
        value={value}
        onChange={(e) => onChange(e)}
        disabled={disabled ? disabled : false}
        options={options}
        KEY_label={KEY_label ? KEY_label : "label"}
        KEY_value={KEY_value ? KEY_value : "id"}
        blankSelect={blankSelect ? blankSelect : "Select"}
        className={className}
        style={style ? style : {}}
        array={array}
        object={object}
        menuPortalTarget={menuPortalTarget}
        component={component}
        placeholder={placeholder}
      />

      {error && <InputError error={error} className={errorClassName} />}
    </FormGroup>
  );
}

export default FormSelect;
